/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "tvs-unified-lib";
import { Fragment, useEffect, useRef, useState } from "react";
import { FlexButton } from "../styles";
import { requestUploadFile } from "@/services/requestUploadFile";
import FileUploadDropzone from "@/components/FileUploadDropzone";
import {
  DropzoneStateEnums,
  FileType,
  UploadFileType,
} from "@/components/FileUploadDropzone/types";
import { useSnackbar } from "notistack";
import useAuthStore from "@/store/authStore";
interface Props {
  setFile: (file) => void;
  setStep: (step: number) => void;
  handleCancel: () => void;
  setSelected: (selected) => void;
}

export const Step2 = ({
  setFile,
  setStep,
  handleCancel,
  setSelected,
}: Props) => {
  const { enqueueSnackbar } = useSnackbar();
  const { user } = useAuthStore((state) => state);
  const timeoutId = useRef<any>(null);
  const [dzState, setDzState] = useState<DropzoneStateEnums>(
    DropzoneStateEnums.IDLE
  );
  const [f, setF] = useState<FileType[] | undefined>(undefined);
  const [uf, setUF] = useState<UploadFileType[] | undefined>(undefined);

  useEffect(() => {
    setSelected([]);
  }, [setSelected]);

  const onFilesUpload = (files: FileList | null) => {
    setUF(null);
    setF(null);

    if (files && files !== null) {
      setDzState(DropzoneStateEnums.UPLOAD);

      const uploadedFiles = [];
      const uploadingFiles = [];
      for (const file of files) {
        uploadingFiles.push({
          file: file,
          uploadPercent: 0,
        });
        uploadedFiles.push({
          file: file,
          uri: file.name,
          type: "document",
        });
      }

      setUF(uploadingFiles);

      timeoutId.current = setTimeout(() => {
        setF(uploadedFiles);
        setUF(undefined);
        setDzState(DropzoneStateEnums.SUCCESS);
      }, 5000);
    }
  };

  const onRemoveFile = () => {
    clearTimeout(timeoutId.current);
    setDzState(DropzoneStateEnums.IDLE);
    setUF(null);
    setF(null);
  };

  const handleUploadFile = async () => {
    try {
      if (!f) return;
      const fileExt = f[0].uri?.split(".")[1];
      const { filename } = await requestUploadFile(
        user?.id,
        fileExt,
        f[0].file
      );
      setFile({
        fileUploadedUrl: filename,
        fileName: f[0].uri,
      });
      if (filename) setStep(3);
    } catch (err: any) {
      enqueueSnackbar(err, {
        variant: "error",
      });
    }
  };

  return (
    <Fragment>
      <FileUploadDropzone
        files={f}
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv"
        uploadingFiles={uf}
        acceptText={"Accepted formats are .csv and .xls"}
        withTimer={true}
        onRemoveFile={() => {
          onRemoveFile();
        }}
        onFilesUpload={(files: FileList | null) => {
          onFilesUpload(files);
        }}
        state={dzState}
      />
      <FlexButton>
        <Button label="Cancel" variant="outline" onClick={handleCancel} />
        <FlexButton>
          <Button label="Previous" onClick={() => setStep(1)} />
          <Button
            label="Next"
            disabled={!f}
            onClick={() => {
              handleUploadFile();
            }}
          />
        </FlexButton>
      </FlexButton>
    </Fragment>
  );
};

export default Step2;
